(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('DiagnosisDialogController', DiagnosisDialogController);

    DiagnosisDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity'];

    function DiagnosisDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity) {
        var vm = this;

        vm.diagnoses = entity.diagnoses;
        vm.clear = clear;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
